// extracted by mini-css-extract-plugin
module.exports = {"info":"AdministrationListHeader_info__1esJT","title":"AdministrationListHeader_title__3MEDk"};